import { Grid } from "@mui/material";
import React from "react";
import QTDetailsImageWithLabelSection from "../../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsTextFieldWithLabelSection from "../../../../../common/QTDetailsTextFieldWithLabelSection";
import QTPhoneFieldWithLabelSection from "../../../../../common/QTPhoneFieldWithLabelSection";
import QTDetailsLatLongSection from "../../../../../common/QTDetailsLatLongSection";
import QTDetailsLocationWithLabelSection from "../../../../../common/QTDetailsLocationWithLabelSection";
import moment from "moment";
import QTDetailsCheckboxWithLabelSection from "../../../../../common/QTDetailsCheckboxWithLabelSection";

const GAOrgDetailsDataFieldsSection = ({
  handleImagePreviewModalOpen,
  editEnabled,
  uploadImage,
  setUploadImage,
  uploadImageOP,
  setUploadImageOP,
  orgDetail,
  setOrgDetail,
}) => {
  // console.log("orgDetail", orgDetail);
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*photo section*/}
        <QTDetailsImageWithLabelSection
          label={"Org Tile Photo"}
          image={orgDetail?.logoUrl}
          fileName={orgDetail?.originalPhotoName}
          handleImagePreviewModalOpen={() => handleImagePreviewModalOpen('main')}
          editEnabled={editEnabled}
          details={orgDetail}
          setDetails={setOrgDetail}
          uploadImage={uploadImage}
          setUploadImage={setUploadImage}
        />
        <QTDetailsImageWithLabelSection
          label={"Org Logo"}
          image={orgDetail?.logoOP}
          fileName={orgDetail?.originalPhotoNameOP}
          handleImagePreviewModalOpen={() => handleImagePreviewModalOpen('logo')}
          editEnabled={editEnabled}
          details={orgDetail}
          setDetails={setOrgDetail}
          uploadImage={uploadImageOP}
          setUploadImage={setUploadImageOP}
        />
        {/*Org Title section*/}

        <QTDetailsTextFieldWithLabelSection
          label={"Org Name"}
          value={orgDetail?.name ?? ""}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setOrgDetail({
              ...orgDetail,
              name: e.target.value,
            })
          }
        />
        {/*Org username section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org Handle"}
          value={orgDetail?.handle ?? ""}
          // value={orgDetail?.userData?.userName}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) => {
            const value = e.target.value;
            setOrgDetail({
              ...orgDetail,
              handle: value
            });

            // setOrgDetail({
            //   ...orgDetail,
            //   handle: e.target.value,
            //   // userData: {
            //   //   ...orgDetail.userData,
            //   //   userName: e.target.value,
            //   // },
            // });
          }}
        />
         {/*location section*/}
         <QTDetailsLocationWithLabelSection
          label={"Location"}
          locationDisplayValue={orgDetail?.locationDisplay}
          value={orgDetail?.location || ""}
          quicktaleDetails={orgDetail}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(docData) => {
            console.log("doc data::", docData);
            setOrgDetail({
              ...orgDetail,
              coordinates: docData.coordinates,
              location: docData.location,
              locationDisplay: docData.locationDisplay,
              locationCountry: docData.locationCountry,
              g: docData.g,
            });
          }}
        />

        {/*Geo Hash section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Geohash"}
          value={orgDetail?.g?.geohash ?? ""}
          disabled={true}
        />
        {/*Lat/long section*/}

        <QTDetailsLatLongSection
          label={"Lat/Long"}
          // orgDetail={orgDetail}
          value={
            orgDetail?.coordinates?._lat ??
            "" + "," + orgDetail?.coordinates?._long ??
            ""
          }
          latValue={orgDetail?.coordinates?._lat ?? ""} 
          longValue={orgDetail?.coordinates?._long ?? ""}
          onChange={(data) => {
            setOrgDetail({
              ...orgDetail,
              coordinates: data.coordinates,
              location: data.location,
              g: data.g,
            });
          }}
          disabled={true}
          editEnabled={editEnabled}
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Org Contact Name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org Contact Name"}
          value={orgDetail.orgContact}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setOrgDetail({
              ...orgDetail,
              orgContact: e.target.value,
            })
          }
        />
        {/*Org Email section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org E-mail"}
          value={orgDetail?.orgEmail}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setOrgDetail({
              ...orgDetail,
              orgEmail: e.target.value,
            })
          }
        />
        {/*Org Phone section*/}
        {/* <QTDetailsTextFieldWithLabelSection
          label={"Org Phone"}
          value={orgDetail?.phone}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setOrgDetail({
              ...orgDetail,
              phone: e.target.value,
            })
          }
        /> */}
        <QTPhoneFieldWithLabelSection
          label={"Org Phone"}
          value={orgDetail?.phone}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setOrgDetail({
              ...orgDetail,
              phone: e.target.value,
            })
          }
        />

        {/*Org Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org Status"}
          value={orgDetail?.status}
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={["active", "inactive", "unlisted"]}
          onChange={(e) =>
            setOrgDetail({
              ...orgDetail,
              status: e.target.value,
            })
          }
        />
        {/*Org ID section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Org ID"}
          value={orgDetail?.id}
          disabled={true}
        />
        {/*Creation Date section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Creation Date"}
          value={
            orgDetail?.createdAt &&
            moment(new Date(orgDetail.createdAt.seconds * 1000)).format(
              "MM/DD/YYYY HH:mm:ss"
            )
          }
          disabled={true}
          // editEnabled={editEnabled}
        />
        {/*Allow Audio Reactions section*/}
        <QTDetailsCheckboxWithLabelSection
          label="Allow Audio Reactions"
          checked={orgDetail?.allowAR ?? false}
          disabled={!editEnabled}
          onChange={(e) => {
            setOrgDetail({
              ...orgDetail,
              allowAR: e.target.checked,
            });
          }}
        />
        {/*Auto-Approve Audio Reactions section*/}
        <QTDetailsCheckboxWithLabelSection
          label="Auto-Approve Audio Reactions"
          checked={orgDetail?.autoApproveAR ?? false}
          disabled={!editEnabled}
          onChange={(e) => {
            setOrgDetail({
              ...orgDetail,
              autoApproveAR: e.target.checked,
            });
          }}
        />
        {/*Feed Priority section (1-100, 50 = neutral)*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Feed Priority"}
          value={orgDetail?.feedPriority ?? 50}
          disabled={true}
          editEnabled={editEnabled}
          placeholder={"50"}
          type={"number"}
          onChange={(e) => {
            const val = e.target.value;
            // Allow empty (revert to default 50) or integers clamped to 1-100.
            if (val === "") {
              setOrgDetail({ ...orgDetail, feedPriority: 50 });
            } else if (/^\d+$/.test(val)) {
              const clamped = Math.min(100, Math.max(1, parseInt(val, 10)));
              setOrgDetail({ ...orgDetail, feedPriority: clamped });
            }
          }}
        />

        {/*Pin Order section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Pin Order"}
          value={orgDetail?.pinOrder ?? ""}
          disabled={true}
          editEnabled={editEnabled}
          placeholder={""}
          type={"number"}
          onChange={(e) => {
            const val = e.target.value;
            // Allow empty string (to clear back to null) or integer values only
            if (val === "" || /^-?\d+$/.test(val)) {
              setOrgDetail({
                ...orgDetail,
                pinOrder: val === "" ? null : parseInt(val, 10),
              });
            }
          }}
        />

      </Grid>
    </Grid>
  );
};

export default GAOrgDetailsDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};
